import React, { useEffect } from 'react';
import { Box, Button, Container, makeStyles, Paper } from '@material-ui/core';
import { Link, RouteComponentProps, useNavigate } from '@reach/router';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SectionHeading from 'components/SectionHeading';
import ProductLoading from '../Loading';
import CartGarment from '../../../Cart/components/Garment';
import NotFound from '../../../components/NotFound';
import AppBackLink from '../../../components/BackLink';
import { selectCartItems } from '../../../Cart/store/selectors';
import { Repair } from '../../../types';
import { getPage } from '../../../utils/pages';
import Steps from '../Steps/Steps';

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: '#F9FAFB',
    border: '1px solid rgba(51, 51, 51, 0.25)',
    padding: theme.spacing(3),
  },
}));

// props
interface ProductSuccessRouteProps {
  seo: string;
}

/**
 * Product add-to-cart-success component.
 */
export default function ProductSuccess({ seo }: RouteComponentProps<ProductSuccessRouteProps>) {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cartItems = useSelector(selectCartItems);
  const headingHtmlId = 'ProductSuccess-heading';
  // const buttonLabelHtmlId = 'ProductSuccess-addRepairButtonLabel';
  let items: Repair[];

  useEffect(() => {
    if (items?.length === 0) {
      navigate('..');
    }
  }, [cartItems, navigate]);

  if (!seo) {
    return <NotFound />;
  }

  if (!cartItems) {
    return <ProductLoading />;
  }

  items = cartItems;

  if (!items.length) {
    return null;
  }

  return (
    <Box>
      <Container maxWidth="xl">
        <Steps currentStep={2} />
        <Box mb={4} />
        <Box>
          <AppBackLink isGoBackActivated />
          <Box mb={3} />
          <SectionHeading id={headingHtmlId} component="h1" size="large" className="with-bar">
            {t('Successfully added to cart')}
          </SectionHeading>
        </Box>
        <Box mb={3} />
      </Container>
      <Container maxWidth="sm">
        <Paper className={classes.card} aria-labelledby={headingHtmlId}>
          <CartGarment items={items} />
        </Paper>
        <Box mb={4} />
        <Box textAlign="center" mb={2}>
          <Button color="secondary" component={Link} to="../../" variant="contained">
            {t('Add another product')}
          </Button>
        </Box>
        <Box textAlign="center">
          <Button color="secondary" component={Link} to={getPage('cart')} variant="contained">
            {t('Go to cart')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
